var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.4 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "cut-off-bottom"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M181.4 0c-25.5 0-55.7 18.8-74 50.2-4.9-11.3-22.5-23.7-43.4-23.7-16.8 0-64 21-64 88.9C0 203 88.6 221 106.5 248.2c1.2 1.9 5.2 3.3 6.7-1.2 14.3-42.2 125.1-89.8 125.1-175.7.1-48.1-31.4-71.3-56.9-71.3zM24.2 111.4c.6-54.3 28.8-71.2 44.2-71.2 21.5 0 30.3 16.4 31.8 23.6 1.4 7.2 9.6 13 12.2 1.2 2.6-11.9 27.9-48.1 58.9-48.1 28.4 0 38.3 29.3 37.4 54.2-2.3 67.9-89.7 122-101.3 156.2-10.3-20.7-83.9-50.7-83.2-115.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cut-off-bottom)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238.4,
    height: 250,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5ab57f379b0847d3b06a8d99ed47a786.svg";
export { ForwardRef as ReactComponent };